import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import MobileDetect from 'mobile-detect';

import FooterLogo from '../../assets/FooterLogos/logo_footer.svg';
import FooterLogoMobile from '../../assets/FooterLogos/logo_mobile.svg';
import MasterCard from '../../assets/FooterLogos/mastercard.svg';
import VisaCard from '../../assets/FooterLogos/visa.svg';
import {  
  MasetroCardLogo,
  CardIcons,  
  Footer as FooterBlock,
  FooterTopContainer,
  LogoMobile
} from './footer.style';
import { FooterBottom } from './components/FooterBottom';
import { Contacts } from './components/Contacts';
import { JuridicialAddress } from './components/JuridicialAddress';
import { Rules } from './components/Rules';

const Footer: React.FC<{}> = () => {  
  const md = new MobileDetect(window.navigator.userAgent);

  return (
    <FooterBlock>
      <Container style={{padding: 0}} fixed>
        <FooterTopContainer container>
          <Grid item xs={12} md={3}>            
            {
              md.mobile() ? (
                <Box>
                  <LogoMobile
                    src={FooterLogoMobile}
                    alt='Footer Logo'
                    loading='lazy'
                  />
                </Box>
              ) : (
                <Box>
                  <img
                    src={FooterLogo}
                    alt='Footer Logo'
                    loading='lazy'
                  />
                  <CardIcons>
                    <MasetroCardLogo
                      src={MasterCard}
                    />
                    <img
                      src={VisaCard}
                      alt='Visa Card'
                      loading='lazy'
                    />
                  </CardIcons>
                </Box>
              )
            }          
          </Grid>
          <Grid item md={3}> 
            <Contacts/>
          </Grid>
          <Grid item md={3}>
            <JuridicialAddress/>
          </Grid>
          <Grid item md={3}>
            <Rules/>
          </Grid>
        </FooterTopContainer>
        {
          !md.mobile() && (
            <FooterBottom />
          ) 
        }       
      </Container>
    </FooterBlock>
  )
};

export default Footer;
